import React, { Component } from "react";
import PropTypes from "prop-types";

import "./Checkbox.scss";

class Checkbox extends Component {

 
  render() {
    const { label, checked, id, chLabelStyle, ...checkboxProps } = this.props;
    return (
      <div className="r-checkbox" style={{
        width: 'max-content'
      }}
>
        <input
          className="styled-checkbox"
          id={id}
          type="checkbox"
          checked={checked}
          {...checkboxProps}
        />
        <label
          className={`${chLabelStyle ? chLabelStyle : ""} checkbox-label`}
          htmlFor={id}
        >
          {label ? label : ""}
        </label>
      </div>
    );
  }
}

export default Checkbox;
Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string
};
